import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import HeaderBotton from '../../../components/HeaderBottom'
import Breadcumb from '../../../components/Breadcumb'
import FooterArea from '../../../components/FooterArea'

// images
import breadcumb from '../../../images/breadcumb/1.jpg'
import './style.scss'
import ContentPrivacyPolicy from "../../../components/ContentPrivacyPolicy";

const breadcumbMenu = [
    { name: 'Inicio', route: '/' },
    { name: 'Aviso de Privacidad' },
]

const PrivacyPolicy = () => {
    return (
        <Fragment>
             <header className="headerArea">
                <HeaderBotton className="headerBottomArea" />
            </header>
            <Breadcumb
                className="breadcumbArea"
                title="Aviso de Privacidad"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />
            <div className="blogPostArea blogFullWidth">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ContentPrivacyPolicy />
                        </div>
                    </div>
                </div>
            </div>
             
            <FooterArea />
        </Fragment>
    )
}
export default PrivacyPolicy